import { useState } from 'react';

export function useJawRotations() {
  const [jawRotations, setJawRotations] = useState({
    UpperJaw: {
      x: 0.15560390055179596,
      y: 0.0904846340417862, 
      z: -0.01941748335957527
    },
    LowerJaw: {
      x: 0.4836086630821228,
      y: 0.03440127894282341,
      z: -0.14018596708774567
    }
  });

  const handleJawRotationChange = (jawName, axis, value) => {
    setJawRotations(prev => ({
      ...prev,
      [jawName]: {
        ...prev[jawName],
        [axis]: parseFloat(value)
      }
    }));
  };

  const handleSavePosition = () => {
    console.log('Current jaw rotations:', JSON.stringify(jawRotations, null, 2));
    // You can implement additional save functionality here
  };

  const jawLimits = {
    UpperJaw: {
      x: { min: 0.15, max: 0.42 },
      y: { min: -0.3, max: 0.3 },
      z: { min: -0.3, max: 0.3 }
    },
    LowerJaw: {
      x: { min: 0.48, max: 1.86 },
      y: { min: -0.3, max: 0.3 },
      z: { min: -0.3, max: 0.3 }
    }
  };

  return {
    jawRotations,
    handleJawRotationChange, 
    handleSavePosition,
    jawLimits
  };
}